export default function getUserAttribute(attribute) {
  return state => state.getIn(['currentUser', 'data', attribute]);
}
